import {HashRouter, Routes, Route} from "react-router-dom"
import getStoreFromProps from "../../store/getStoreFromProps";
import { useEffect } from "react";
import { CustomHeader } from "../../component/CustomHeader/CustomHeader";
import { NewDataset } from "../NewDataset/NewDataset";
import { inject, observer } from "mobx-react";
import LoginDialog from "../../component/LoginDialog/LoginDialog";
import { TrainManageDialog } from "../../component/TrainManageDialog/TrainManageDialog";
import { useState } from "react";
import { msgbox, MSG_TYPE } from "../../utils/Msgbox";
import { PublishModel } from "../../component/PublishModel/PublishModel";
import { needLogin } from "../../utils/decor";
import "./Main.less"

export const FULLSCREEN_MOUNT = "fullscreenMount";
export const PAGE_NEW_DATASET: string = "newDataset";

export const Main = inject("common", "dataset", "trainManage")(observer((props:any): React.ReactElement => {
    const commonStore = getStoreFromProps(props, "common");
    const datasetStore = getStoreFromProps(props, "dataset");
    const trainManageStore = getStoreFromProps(props, "trainManage");
    const [isTrainManageVisible, setIsTrainManageVisible] = useState(false);
    const [isPublishModelVisible, setIsPublishModelVisible] = useState(false);

    // 处理缓存token
    const processCacheToken = (): void => {
        const token = localStorage.getItem("token") || "";
        if(token.length <= 0){
            return;
        }
    
        commonStore.updateLoading(true);
        commonStore.autoLogin(token)
            .then(() => {
                Promise.all([datasetStore.init(), trainManageStore.init()])
                    .catch(reason => msgbox(reason.message, MSG_TYPE.ERROR))
                    .finally(() => commonStore.updateLoading(false));
            })
            .catch(_ => () => commonStore.updateLoading(false));
    };

    // 处理登录返回token
    const processReturnToken = (): boolean => {
        const url = new URL(window.location.href);
        const token = url.searchParams.get("token");
        if(!!token){
            window.localStorage.setItem("token", token);
            url.searchParams.delete("token");
            window.location.href = url.href;
            return true;
        }

        return false;
    };

    const spin = (): React.ReactElement => {
        if(!commonStore.loading){
            return <></>
        }

        return <div className="main-spin-wrap">
            <div className="main-spin"></div>
        </div>;
    };

    const onTrainManageBtnClick = needLogin((): void => {
        setIsTrainManageVisible(true);
    });

    const onTrainManageClose = (): void => {
        setIsTrainManageVisible(false);
    };

    const onPublishModelClose = (): void => {
        setIsPublishModelVisible(false);
    };

    const onTrainManagePublishClick = (): void => {
        setIsTrainManageVisible(false);
        setIsPublishModelVisible(true);
    };

    const init = (): void => {
        if(!processReturnToken()){
            processCacheToken();
        }
    };

    useEffect(init, []);

    return <div className="main main-vars">
        <CustomHeader onTrainManageBtnClick={onTrainManageBtnClick}></CustomHeader>
        <div className="main-content">
            <HashRouter>
                <Routes>
                    <Route path="/" element={<NewDataset></NewDataset>}></Route>
                    <Route path={PAGE_NEW_DATASET} element={<NewDataset></NewDataset>}></Route>
                </Routes>
            </HashRouter>
        </div>
        <LoginDialog></LoginDialog>
        {isTrainManageVisible && <TrainManageDialog onClose={onTrainManageClose} onPublishClick={onTrainManagePublishClick}></TrainManageDialog>}
        {isPublishModelVisible && <PublishModel onClose={onPublishModelClose} model={trainManageStore.history[0].models[0]}></PublishModel>}
        <div id={FULLSCREEN_MOUNT}></div>
        {spin()}
    </div>;
}));